const defs = [
  {
    title: "Annonsdetaljer",
    key: "AD_DETAILS",
    visited: true,
    hasError: false,
    fieldKeys: [],
  },
  {
    title: "Publicera annonser",
    key: "PUBLISH",
    visited: false,
    hasError: false,
    fieldKeys: [],
  },
  {
    title: "Annonsbeskrivning",
    key: "DESCRIPTION",
    visited: false,
    hasError: false,
    fieldKeys: [],
  },

  {
    title: "Gå vidare",
    key: "CONFIRM",
    visited: false,
    hasError: false,
    fieldKeys: [],
  },
];

export default () => {
  return defs;
};
